import React from 'react';
import logo from './logo.svg';
import styles from './App.module.css';
import { EissaTextLogo } from 'react-reusable-elements';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import { products } from './utils/products';
import ProductCard from './components/ProductCard/ProductCard';

function App() {


  return (
    <div className="App">
      <Navbar/>
      <Hero/>
      <div className={styles.cta_container}>
    
      </div>
      <div className={styles.products_cards}>
        {
          products.map((product, index)=>{
            return <ProductCard product = {product}/>
          })
        }
      </div>
    </div>
  );
}

export default App;
